import { api, createCancelTokenHandler } from '../vodea/services';

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  all: function (params: any = null) {
    return api.get(`${endPoint()}/api/expense-category`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.all.name].handleRequestCancellation().token
    });
  },
  show: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/expense-category/${id}`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.show.name].handleRequestCancellation().token
    });
  },
  select: function (params: any = null) {
    return api.get(`${endPoint()}/api/expense-category`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.select.name].handleRequestCancellation().token
    });
  },
  create: function (payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/expense-category`, payload, {
      params,
      cancelToken: cancelTokenHandlerObject[this.create.name].handleRequestCancellation().token
    });
  },
  update: function (id: number | string, payload: any, params: any = null) {
    return api.put(`${endPoint()}/api/expense-category/${id}`, payload, {
      params,
      cancelToken: cancelTokenHandlerObject[this.update.name].handleRequestCancellation().token
    });
  },
  delete: function (id: number | string, params: any = null) {
    return api.delete(`${endPoint()}/api/expense-category/${id}`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.delete.name].handleRequestCancellation().token
    });
  }
};

export default Repository;

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);
